/**
 * Pagina Glossario: elenca i termini del dominio CRA con una descrizione
 * breve (sempre visibile) e una lunga (contesto/uso nel portale). Contenuto
 * statico da glossary.content.ts — nessuna chiamata di rete.
 */

import { GLOSSARY } from './glossary.content.js';
import styles from './GlossarioPage.module.css';

export function GlossarioPage() {
  return (
    <section className={styles.page} data-testid="glossary-page">
      <h1 className={styles.title}>Glossario</h1>
      <p className={styles.intro}>
        Termini e sigle ricorrenti nel portale CRA. Ogni voce riporta una definizione breve e una
        spiegazione estesa con il contesto d’uso.
      </p>
      <ul className={styles.list}>
        {GLOSSARY.map((entry) => (
          <li key={entry.term} className={styles.entry} data-testid="glossary-entry">
            <div className={styles.termRow}>
              <h2 className={styles.term}>{entry.term}</h2>
              {entry.expansion && <span className={styles.expansion}>{entry.expansion}</span>}
            </div>
            <p className={styles.short}>{entry.short}</p>
            <p className={styles.long}>{entry.long}</p>
          </li>
        ))}
      </ul>
    </section>
  );
}
